import {Injectable} from "@angular/core";
import {CanActivate} from "@angular/router";
import {IAuthenticationService} from "../../domain/server/IAuthenticationService";
import {NavigationService} from "../../presentation/navigation/NavigationService";


@Injectable()
export class IsAdminAuthenticationGuard implements CanActivate {

    constructor(private navigationService:NavigationService, private authService: IAuthenticationService) {}

    canActivate() {
        if(this.authService.IsUserAdmin()){
            return true;
        }else{
            this.navigationService.Navigate('admin');
            return false;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/server/RouteGardService.ts